<template>
        <div class="min-h-screen bg-gray-50 font-sans">
                <!-- Header -->
                <header class="bg-white border-b border-gray-200 px-3 py-4">
                        <div class="w-full flex justify-between items-center flex-wrap gap-2">
                                <div>
                                        <button
                                                class="inline-flex items-center gap-1 text-orange-7 bg-transparent border-none cursor-pointer text-sm p-0 mb-2 hover:text-orange-6"
                                                @click="goBack"
                                        >
                                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                                </svg>
                                                Back to Products Ordered
                                        </button>
                                        <h1 class="text-2xl font-semibold text-gray-900 m-0">User Properties</h1>
                                        <p class="text-sm text-gray-500 mt-1 m-0">User #{{ routeId }}</p>
                                </div>
                        </div>
                </header>

                <!-- Main Content -->
                <main class="w-full p-3">
                        <div class="bg-white rounded-xl shadow-sm p-12 text-center">
                                <div class="text-gray-500">
                                        <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        <h2 class="text-xl font-semibold text-gray-700 mb-2 m-0">User Properties</h2>
                                        <p class="text-gray-500 m-0">This module is being refactored to the new design system.</p>
                                </div>
                        </div>
                </main>
        </div>
</template>

<script lang="ts">
import { defineComponent, computed, ComputedRef } from 'vue';
import { useRouter, useRoute, Router, RouteLocationNormalizedLoaded } from 'vue-router';

export default defineComponent({
        name: 'UserPropertiesPage',
        setup() {
                const router: Router = useRouter();
                const route: RouteLocationNormalizedLoaded = useRoute();

                const routeId: ComputedRef<string | string[]> = computed(() => route.params.id);

                const goBack = (): void => {
                        router.push('/products-ordered');
                };

                return {
                        routeId,
                        goBack,
                };
        },
});
</script>
